import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TwoColumnFormFields = ({
  className = '',
  children,
  oneColumnOnTablet = false,
}) => {
  const numberOfFields = React.Children.count(children);

  // Ensure that exactly 2 fields have been passed in
  if (numberOfFields !== 2) {
    return null;
  }

  return (
    <div
      className={classNames(
        `lg:items-start lg:flex lg:mx-0 lg:my-3 [&>*]:lg:flex-1 [&>*]:first:lg:mr-3 [&_[data-xc="LabeledFieldWrapper"]]:lg:!mt-0 [&_[data-xc="LabeledFieldWrapper"]]:lg:!mb-0 !gap-2 ${className}`,
        {
          'md:items-start md:flex md:mx-0 md:my-3 [&>*]:md:flex-1 [&>*]:first:md:mr-3 [&_[data-xc="LabeledFieldWrapper"]]:md:!mt-0 [&_[data-xc="LabeledFieldWrapper"]]:md:!mb-0': !oneColumnOnTablet,
        }
      )}
    >
      {children}
    </div>
  );
};

TwoColumnFormFields.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  oneColumnOnTablet: PropTypes.bool,
};

export default TwoColumnFormFields;
